import React from 'react'

const SiteContainer = ({ children }) => <div className="root">{children}</div>

export default SiteContainer
